/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('BoardDinghyBookingSearch', BoardDinghyBookingSearch);

    BoardDinghyBookingSearch.$inject = ['$resource'];

    function BoardDinghyBookingSearch($resource) {
        var resourceUrl =  'api/_search/board/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
